import { Component, Inject, Input, OnInit, Optional, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
//import { StateService } from '@uirouter/core';
//import { AppService } from 'projects/gtw-elements/src/app/app.service';
//import { GridEventService } from 'projects/gtw-elements/src/app/core/grid/services/grid-event.service';
//import { GlobalService } from 'projects/gtw-elements/src/app/global/services/global.service';
//import { GtwSnackbarService } from 'projects/gtw-elements/src/app/shared/_services/gtw-snackbar.service';
//import { UserAdminService } from '../../users-component/user-admin.service';
import { UserAccessApprovalService } from '../user-access-approval.service';
import { environment } from 'projects/gtw-elements/src/environments/environment';
//import { ExcelService } from './excel.service';
//import * as FileSaver from 'file-saver';
import { downloadXlsxBuffer, jsonRowsToAoA, writeXlsxBuffer } from 'projects/gtw-elements/src/app/shared/_utils/excel-workbook.util';
import * as _ from 'lodash-es';

@Component({
    selector: 'gtw-view-request-history',
    templateUrl: './view-request-history.component.html',
    styleUrls: ['./view-request-history.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ViewRequestHistoryComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);


	GENERAL_CONFIG : any;
	pendingRequests: any;
	loading: any;
	minimise: any;
	title: any;
	requestStatus: any;
	selectedStatus: any;
	EXCEL_TYPE = 'application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet;charset=UTF-8';
	EXCEL_EXTENSION = '.xlsx';
	globalService: any;

	@Input('header-data')
	set headerData(headerData : any){
		try{
			this.globalService = headerData;
			this.GENERAL_CONFIG = this.globalService.generalConfigData;
			this.init();
		}catch(e){
			console.log("Input Not yet stable. Still waiting to get resolved.");
		}
	}

	constructor(
		//private stateService: StateService,
		//private appService: AppService,
		//private UserAdminFactory: UserAdminService,
		//private AlertService: GtwSnackbarService,
		//private gridEventService: GridEventService,
		private userAccessApprovalService: UserAccessApprovalService
		//private globalService: GlobalService,
		//private dialog: MatDialog,
		//ublic diagRef: MatDialogRef<any>,
		//@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
		//private excelService: ExcelService,
	) { }

	ngOnInit(): void {
		//this.GENERAL_CONFIG = environment;
		this.title = "View History";
		this.requestStatus = [
		{ label: 'Approved', value: 'APPROVED' },
		{ label: 'Rejected', value: 'REJECTED' }
		];
		this.selectedStatus = 'APPROVED';

	}

	init(){
		this.getPendingRequestsData('APPROVED');
	}

	// downloadData() {
	//   const blob = new Blob(this.pendingRequests, { type: 'application/octet-stream' });
	//   const url= window.URL.createObjectURL(blob);
	//   window.open(url);
	// }

	saveAsExcelFile(buffer: ArrayBuffer, fileName: string) {
			let todaysDate : any;
			todaysDate = new Date();
			downloadXlsxBuffer(buffer, fileName + '_export_' + todaysDate + this.EXCEL_EXTENSION);
		}

	exportAsExcelFile(json: any[], excelFileName: string) {
			writeXlsxBuffer([{ name: 'data', aoa: jsonRowsToAoA(json) }]).then((buffer) => {
				this.saveAsExcelFile(buffer, excelFileName);
			});
		}


	statusChanged(status: any){
		console.log(status);
		this.pendingRequests = [];
		this.getPendingRequestsData(status);
	}

		getPendingRequestsData(status: any) {
			// let data: any = {};
			// data.user_id = this.user_id;
			// this.loading = true;

			this.userAccessApprovalService.getAllPendingRequests( this.GENERAL_CONFIG.base_url, this.globalService.userSettingsData.user, status).pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (data: any) => {
				if (data.jsonObject.length > 0) {
					_.forEach(data.jsonObject, (item, index) => {
						item.INDEX = index;
					});
					this.pendingRequests = data.jsonObject;
					console.log("New user access data loaded");
				} else {
					console.log("Error");
				}
				}, (error) => {
				console.log(error);
				}, () => {
				console.log('Completed loading');
			});
		}

	//   cancel(){
	// 		this.diagRef.close();
	// 	};

}
